import { API_CONFIG } from "./config";

export const createContactInquiry = async (contactPayload) => {
  if (!API_CONFIG.sharedApiBaseUrl || !API_CONFIG.institutionReference) {
    throw new Error("Contact API configuration is missing.");
  }

  const response = await fetch(`${API_CONFIG.sharedApiBaseUrl}/contact-inquiries`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      accept: "*/*",
    },
    body: JSON.stringify({
      ...contactPayload,
      institutionReference: API_CONFIG.institutionReference,
    }),
  });

  if (!response.ok) {
    throw new Error(`Contact inquiry failed with ${response.status}`);
  }

  const payload = await response.json();
  if (payload?.status !== 1) {
    throw new Error(payload?.error?.message || "Unable to submit your inquiry.");
  }

  return payload?.data;
};

export const fetchRoomTypes = async () => {
  if (!API_CONFIG.sharedApiBaseUrl) {
    throw new Error("Contact API configuration is missing.");
  }

  const response = await fetch(`${API_CONFIG.sharedApiBaseUrl}/room-type`, {
    headers: { accept: "*/*" },
  });

  if (!response.ok) {
    throw new Error(`Room types request failed with ${response.status}`);
  }

  const payload = await response.json();
  if (payload?.status !== 1) {
    throw new Error(payload?.error?.message || "Unable to load room types.");
  }

  return (payload?.data || []).map((roomType) => ({
    id: String(roomType.roomTypeId),
    name: roomType.name,
  }));
};
